(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) { module.exports = factory; return; }
  if (root.CentralSportExpressDeliveryAnnouncement) return;
  root.CentralSportExpressDeliveryAnnouncement = factory(root);
})(typeof window !== 'undefined' ? window : globalThis, function createExpressDeliveryAnnouncement(runtime) {
  'use strict';
  var EVENT = 'cs:express-delivery:updated';
  var RETRY_INTERVAL = 100;
  var RETRY_LIMIT = 3000;

  function presentation(engine, data) {
    function withText(text, status) {
      var normalized = String(text || '').replace(/\u00a0/g, ' ').trim();
      return { visible: normalized !== '', status: status, text: normalized };
    }
    if (!engine || typeof engine.resolveDelivery !== 'function') {
      return withText(data.fallbackText, 'fallback');
    }
    try {
      var result = engine.resolveDelivery({ product: { eligible: true, available: true } });
      if (result.visible === false) return { visible: false, status: result.status || result.state || 'unavailable', text: '' };
      if (result.status === 'today') return withText(data.todayText, 'today');
      if (result.status === 'next_business_day') return withText(data.nextText, 'next_business_day');
      if (result.status === 'weekend') return withText(data.weekendText, 'weekend');
      if (result.status === 'holiday' || result.status === 'blackout') {
        return withText(data.nonOperationalText, result.status);
      }
      return withText(data.fallbackText, 'fallback');
    } catch (error) {
      return withText(data.errorText, 'error');
    }
  }

  function update(element) {
    var result = presentation(runtime && runtime.CentralSportExpressDelivery, element.dataset || {});
    var text = element.querySelector('[data-cs-express-announcement-text]');
    var emoji = element.querySelector('[data-cs-express-announcement-emoji]');
    var slide = typeof element.closest === 'function' ? element.closest('.slide-item') : null;
    element.hidden = result.visible === false;
    if (slide) slide.hidden = result.visible === false;
    [element, slide].forEach(function (target) {
      if (!target || !target.style || typeof target.style.setProperty !== 'function') return;
      if (result.visible === false) target.style.setProperty('display', 'none');
      else target.style.removeProperty('display');
    });
    if (text) text.textContent = result.text;
    if (emoji) emoji.textContent = element.dataset.emoji || '⚡';
    element.dataset.csStatus = result.status;
  }

  function syncFromEngine(element) {
    if (!element || element.isConnected === false) return false;
    var engine = runtime && runtime.CentralSportExpressDelivery;
    if (!engine || typeof engine.resolveDelivery !== 'function') return false;

    var result = presentation(engine, element.dataset || {});
    var text = element.querySelector('[data-cs-express-announcement-text]');
    var emoji = element.querySelector('[data-cs-express-announcement-emoji]');
    var slide = typeof element.closest === 'function' ? element.closest('.slide-item') : null;
    var hidden = result.visible === false;

    if (element.dataset.csStatus === result.status
      && (!text || text.textContent === result.text)
      && element.hidden === hidden
      && (!slide || slide.hidden === hidden)) return true;

    if (element.hidden !== hidden) element.hidden = hidden;
    if (slide && slide.hidden !== hidden) slide.hidden = hidden;
    [element, slide].forEach(function (target) {
      if (!target || !target.style || typeof target.style.setProperty !== 'function') return;
      if (hidden) target.style.setProperty('display', 'none');
      else target.style.removeProperty('display');
    });
    if (text && text.textContent !== result.text) text.textContent = result.text;
    var emojiText = element.dataset.emoji || '⚡';
    if (emoji && emoji.textContent !== emojiText) emoji.textContent = emojiText;
    if (element.dataset.csStatus !== result.status) element.dataset.csStatus = result.status;
    return true;
  }

  function register() {
    if (!runtime || !runtime.customElements || !runtime.HTMLElement || runtime.customElements.get('cs-express-delivery-announcement')) return;
    class ExpressAnnouncement extends runtime.HTMLElement {
      constructor() {
        super();
        this.csRetryTimer = null;
        this.csRetryElapsed = 0;
        this.csUpdate = () => {
          if (syncFromEngine(this)) this.csStopRetry();
        };
      }
      csStopRetry() {
        if (this.csRetryTimer !== null && runtime && typeof runtime.clearTimeout === 'function') {
          runtime.clearTimeout(this.csRetryTimer);
        }
        this.csRetryTimer = null;
        this.csRetryElapsed = 0;
      }
      csStartRetry() {
        if (this.csRetryTimer !== null || !runtime || typeof runtime.setTimeout !== 'function') return;
        var retry = () => {
          this.csRetryTimer = null;
          if (this.isConnected === false || syncFromEngine(this)) {
            this.csStopRetry();
            return;
          }
          this.csRetryElapsed += RETRY_INTERVAL;
          if (this.csRetryElapsed >= RETRY_LIMIT) {
            this.csStopRetry();
            return;
          }
          this.csRetryTimer = runtime.setTimeout(retry, RETRY_INTERVAL);
        };
        this.csRetryTimer = runtime.setTimeout(retry, RETRY_INTERVAL);
      }
      connectedCallback() {
        if (this.csListening) return;
        this.csListening = true;
        runtime.document.addEventListener(EVENT, this.csUpdate);
        if (!syncFromEngine(this)) {
          update(this);
          this.csStartRetry();
        }
      }
      disconnectedCallback() {
        this.csStopRetry();
        if (this.csListening) runtime.document.removeEventListener(EVENT, this.csUpdate);
        this.csListening = false;
      }
    }
    runtime.customElements.define('cs-express-delivery-announcement', ExpressAnnouncement);
  }

  register();
  return Object.freeze({
    namespace: 'cs-express-delivery-announcement',
    presentation: presentation,
    update: update,
    syncFromEngine: syncFromEngine
  });
});
